
import EstimatedExchangeRate from "@/store/modules/system/estimatedexchangerate/entity";
import { Component, Mixins, ActionButtonConfig, FormModalMixins } from "@/lib";

@Component
export default class EditEstimatedExchangeRate extends Mixins(FormModalMixins) {
  model = new EstimatedExchangeRate();
  created() {
    Object.assign(this.config, { modelTitleL: "Action.Edit", labelWidth: 200, okAction: "system/estimatedexchangerate/update" });
  }
  get record() {
    return this.$store.state.system.estimatedexchangerate.editEstimatedExchangeRate;
  }
}
